import type { LabelStyle } from '@astrasonora/annotation-schema'
import { romanDegree } from './sky.ts'

/**
 * Nashville display of a Roman label (spec §3): numeral → digit, lower case → digit + `m`,
 * `°`, `ø`, accidentals and `/x` kept, every seventh as a superscript 7.
 */
export function toNashville(text: string): string {
  const sevenths = text.replace(/7/g, '⁷')
  return sevenths.replace(/([IVX]+|[ivx]+)([°ø])?/g, (m, num: string, sym: string | undefined) => {
    const upper = num === num.toUpperCase()
    const degree = romanDegree(num)
    if (degree === undefined) return m
    const digit = String(degree + 1)
    // a diminished symbol already says minor; `7°`, `7ø⁷`
    return digit + (upper || sym ? '' : 'm') + (sym ?? '')
  })
}

export function displayLabel(text: string, style: LabelStyle): string {
  return style === 'nashville' ? toNashville(text) : text
}
